import { ConfirmationCreateDialog, ConfirmationEditDialog } from '../../dialogs';
import { useDialogProps } from './ModalTabbarProvider';

export const ModalTabbarConfirmationCreateDialog = () => <ConfirmationCreateDialog {...useDialogProps()} />;
export const ModalTabbarConfirmationEditDialog = () => <ConfirmationEditDialog {...useDialogProps()} />;
